import { LabelCheckValue } from '@ulysses-inc/harami_api_client'
import React from 'react'
import { LabelCheckAnswerForPDF } from 'src/features/labelCheck/components/pdf/LabelCheckAnswerForPDF'

type Props = {
  questionName: string
  labelCheckValue?: LabelCheckValue
}

export const LabelCheck: React.FC<Props> = ({
  questionName,
  labelCheckValue,
}: Props) => {
  return (
    <LabelCheckAnswerForPDF
      labelCheckValue={labelCheckValue}
      questionName={questionName}
    />
  )
}
